var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',[(_vm.detail)?_c('Container',[_c('TrainingLiveItem',{attrs:{"data":_vm.detail}}),_vm._v(" "),_c('XImage',{attrs:{"width":"100%","src":_vm.detail.qrCodeUrl}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }